import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableAdvertisingCashier from 'views/betShopManagement/cashier/tableAdvertisingCashier'; // Importing TableAdvertisingCashier component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the advertising cashier view.
 * @extends JetView
 */
export default class betShopAdvertisingCashierView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Event listener for advertising cashier selection
        this.on(this.app, 'advertisingCashier:select', (id) => {
            $$('tittle').setValue('Cajero ' + id.row); // Update title with selected cashier ID
        });

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration
        const left = {
            responsiveCell: false,
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Añadir Publicidad Cajero'), // Accordion header
                            body: {
                                rows: [
                                    {
                                        padding: 5,
                                        height: 50,
                                        cols: [
                                            {
                                                view: 'toolbar',
                                                elements: [
                                                    {
                                                        view: 'label',
                                                        id: 'tittle', // Title label ID
                                                    },
                                                ],
                                            },
                                            {},
                                            {
                                                view: 'button',
                                                value: _('Añadir Publicidad'), // Button label
                                                type: 'form',
                                                hidden: !devConfig.getPermAction(
                                                    // Button visibility based on permissions
                                                    'permAdvertisingCashier',
                                                    'Add',
                                                ),
                                                css: 'prm-permAdvertisingCashier', // Button CSS class
                                                click: () => {
                                                    this.app.callEvent(
                                                        // Event call on button click
                                                        'addAdvertisingCashier:button',
                                                        [[]],
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                    TableAdvertisingCashier, // Including TableAdvertisingCashier component
                                    toolbar, // Including toolbar
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main configuration object for the view
        return {
            type: 'wide',
            id: 'tableAdvertisingCashier', // View ID
            responsive: true,
            cols: [left], // Left panel as a column
        };
    }

    /**
     * Initializes the view components.
     */
    init() {
        $$('tableAdvertisingCashier').hide(); // Hides the tableAdvertisingCashier component initially
    }
}

// FILE DOCUMENTED
